import { inject, Injectable } from '@angular/core';
import type { ModalModel } from '@dev-fast/types';
import { ModalNames } from '@dev-fast/types';
import { Store } from '@ngxs/store';
import type { Observable } from 'rxjs';

import { ModalsService } from '@app/core/modal-service';
import { CloseModal, OpenModal } from '@app/core/state/modals';

import { AprilMadnessFaqModalComponent, AprilMadnessOpenCaseModalComponent } from '../ui/modals';

const APRIL_MADNESS_LEVEL_PROGRESS_MODAL_NAME = ModalNames.HUMANIZATION_EVENT_LEVEL_PROGRESS;
const APRIL_MADNESS_OPEN_CASE_MODAL_NAME = ModalNames.ICE_BREAKERS_EVENT_OPEN_CASE;
const APRIL_MADNESS_FAQ_MODAL_NAME = ModalNames.ICE_BREAKERS_FAQ;

@Injectable({
  providedIn: 'root',
})
export class AprilMadnessEventModalsService {
  readonly #modalsService = inject(ModalsService);
  readonly #store = inject(Store);

  #modals: ModalModel[] = [
    {
      name: APRIL_MADNESS_OPEN_CASE_MODAL_NAME,
      component: AprilMadnessOpenCaseModalComponent,
      config: {
        width: '100vw',
        height: '100dvh',
        maxWidth: '100vw',
        panelClass: 'humanization-event-progress-panel',
      },
    },
    {
      name: APRIL_MADNESS_FAQ_MODAL_NAME,
      component: AprilMadnessFaqModalComponent,
      config: {
        width: '47rem',
        height: 'max-content',
        maxWidth: '100vw',
        panelClass: 'april-madness-faq-modal',
        mobileViewAllowed: true,
      },
    },
  ];

  registerModals(): void {
    this.#modalsService.registerModals(this.#modals);
  }

  openLevelProgressModal = (): Observable<void> => this.#store.dispatch(new OpenModal(APRIL_MADNESS_LEVEL_PROGRESS_MODAL_NAME));
  openOpenCaseModal = (payload: { step: number; isReplay?: boolean; levelBackendId?: number; viewOnly?: boolean }): Observable<void> =>
    this.#store.dispatch(new OpenModal(APRIL_MADNESS_OPEN_CASE_MODAL_NAME, payload));

  openFaqModal = (): Observable<void> => this.#store.dispatch(new OpenModal(APRIL_MADNESS_FAQ_MODAL_NAME));

  closeOpenCaseModal = (): Observable<void> => this.#store.dispatch(new CloseModal(APRIL_MADNESS_OPEN_CASE_MODAL_NAME));
  closeFaqModal = (): Observable<void> => this.#store.dispatch(new CloseModal(APRIL_MADNESS_FAQ_MODAL_NAME));
}
